<div class="container-fluid p-4 ">
  <div class=" custom-datatable noscroll">
    <div class="custom-datatable table-responsive">
      <table class="table table-responsive">
        <thead class="table-secondary f-16">
          <tr>
          <th>
            <input  type="checkbox" class="form-check-input border border-secondary">
          </th>
            <th *ngFor="let col of columns" scope="col" (click)="onSort(col.key)" [class.sortable]="col.sortable">
              {{ col.label }}
            </th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let item of displayedData" (click)="onRowClick(item)">
            <td>   
           <input  type="checkbox" class="form-check-input border border-secondary">
            
            </td>
            <td *ngFor="let col of columns">
              <ng-container [ngSwitch]="col.type">
                <ng-container *ngSwitchCase="'image'">
                  <img class="img-40 me-2" [src]="item[col.key]" alt="Image">
                  <!-- <img class="img-40 me-2" [src]="item.imageUrl" alt="Product Image" style="max-width: 40px; max-height: 40px;" /> -->
                  <!-- {{ item[col.key] }} -->
                  {{ item.productName }}
                </ng-container>
                <ng-container *ngSwitchDefault>
                  {{ item[col.key] }}
                </ng-container>
              </ng-container>
            </td>
            <td>
              <div class="action">
                <a href="#" class="edit"><i class="icon-pencil-alt"></i></a>
                <a href="#" class="delete" (click)="onDelete(item)"><i class="icon-trash"></i></a>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <!-- Pagination component -->
    <app-data-pagination
      [totalItems]="collectionSize"
      [pageSize]="pageSize"
      [currentPage]="currentPage"
      (pageChange)="onPageChange($event)"
      (itemsPerPageChange)="onItemsPerPageChange($event)">
    </app-data-pagination>

  </div>
</div>
